import side from './side'
import back from './back'
import top from './top'
import palm from 'data/baseball/shado-elite/palm'
import { config } from 'data/baseball/shado-elite'

const data = {
  config,
  side,
  back,
  top,
  palm,
}

export default data
